import { getToken } from '../auth/tokenStore';
import { User } from '../common/types';
import { apiBaseUrl } from '../index';

export type InitializeUserRequest = {
  id?: string;
  name: string;
  email: string;
  tier?: string;
};

// Create a new client
export const createUser = async (name: string, email: string): Promise<User> => {
  const accessToken: string = await getToken();
  const response = await fetch(`${apiBaseUrl}/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify({ name: name, email: email })
  });
  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  return response.json();
};

// Retrieve the current user
export const getCurrentUser = async (): Promise<User> => {
  const accessToken: string = await getToken();
  const response = await fetch(`${apiBaseUrl}/users/me`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  return await response.json();
};

// Delete user from our DB and Azure AD B2C
export const deleteUser = async (): Promise<void> => {
  const accessToken: string = await getToken();

  const response = await fetch(`${apiBaseUrl}/users/me`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }
};

// Initialize user after login either by retrieving it or creating it
export const initiliazeUser = async (user: InitializeUserRequest): Promise<User> => {
  const accessToken: string = await getToken();
  const response = await fetch(`${apiBaseUrl}/users/initialize`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(user)
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  return response.json();
};
